import React from 'react';
import { View, TouchableHighlight } from 'react-native';
import { COLORS } from '../constants'

import { MaterialIcons } from '@expo/vector-icons';


const LeftBackBtn = ({ onPress }) => {
  return (
    <TouchableHighlight
      onPress={onPress}          
    >
      <View style={{
        paddingLeft: 0,
        marginRight: 0,
        paddingRight: 0
      }}>
      <MaterialIcons name="chevron-left" size={42} color={COLORS.primary} />
      </View>
    </TouchableHighlight>
  )
}

export default LeftBackBtn;